import { AtcGraphCalculation } from './advance-tax-calculator/atc-graph-calculation';
import AtcBasicDetails from './advance-tax-calculator/AtcBasicDetails';
import AtcDeductions from './advance-tax-calculator/AtcDeductions';
import AtcIncomeDetails from './advance-tax-calculator/AtcIncomeDetails';
import AtcTaxPaid from './advance-tax-calculator/AtcTaxPaid';
import { AtctabsData, tabsData } from './types';

export const AtcBasicDetailsData = [
  {
    id: 'EntityType',
    label: 'PAN of',
    value: 'Individual',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label: 'Individual',
        value: 'Individual',
      },
      {
        id: 'id2',
        label: 'HUF',
        value: 'HUF',
      },
      {
        id: 'id3',
        label: 'AOP/BOI',
        value: 'AOP',
      },
      {
        id: 'id4',
        label: 'Company Public',
        value: 'CompanyPublicInterested',
      },
      {
        id: 'id5',
        label: 'Company Private',
        value: 'CompanyPublicNotInterested',
      },
      {
        id: 'id6',
        label: 'Firm',
        value: 'Firm',
      },
      {
        id: 'id7',
        label: 'Cooperative Society',
        value: 'OtherCooperativeSociety',
      },
      {
        id: 'id8',
        label: 'LLP',
        value: 'LLP',
      },
    ],
    onChange: () => {},
    placeholder: 'Individual',
  },
  {
    id: 'AgeGroup',
    label: 'Age group',
    value: '0-60',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label: '0-60',
        value: 'NotSenior',
      },
      {
        id: 'id2',
        label: '60-80',
        value: 'Senior',
      },
      {
        id: 'id3',
        label: '80 & above',
        value: 'SuperSenior',
      },
    ],
    onChange: () => {},
    placeholder: '0-60',
  },
  {
    id: 'ResidentialStatus',
    label: 'Residential status',
    value: 'Resident',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label: 'Resident',
        value: 'Resident',
      },
      {
        id: 'id2',
        label: 'Non Resident',
        value: 'NonResident',
      },
    ],
    onChange: () => {},
    placeholder: 'Resident',
  },
];

export const AtcIncomeDetailsData = [
  {
    label: 'Income from Salary',
    showLabel: true,
    id: 'TaxableSalary',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },

    info: {
      enabled: true,
      text: 'Salary after reducing Exemptions (HRA, LTA) & Professional Tax',
    },
  },
  {
    label: 'Income from interest',
    showLabel: true,
    id: 'InterestIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Includes interest from Savings Bank, Deposits and Other Interest',
    },
  },
  {
    label: 'Rental income received',
    showLabel: true,
    id: 'RentalPropertyIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Annual rent received on let-out property (Standard deduction @30% will be auto calculated)',
    },
  },
  {
    label: 'Interest Paid on Housing Loan',
    showLabel: true,
    id: 'HousePropertyInterest',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Interest paid on housing loan taken for self-occupied property',
    },
  },
];

export const AtcCapitalGainsAmount = [
  {
    id: 'GainOrLoss',
    label: 'Gain Amount',
    showLabel: true,
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Please enter the profit amount',
    },
  },
];

export const AtcCapitalGainsData = [
  {
    id: 'Category',
    label: 'Asset Category',
    value: 'EquityMutualFunds',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label: 'Equity Mutual Funds',
        value: 'EquityMutualFunds',
      },
      {
        id: 'id2',
        label: 'Non Equity Or Debt Mutual Funds',
        value: 'NonEquityOrDebtMutualFunds',
      },
      {
        id: 'id3',
        label: 'Listed Equity Shares',
        value: 'ListedEquityShares',
      },
      {
        id: 'id4',
        label: 'Unlisted Equity Shares',
        value: 'UnlistedEquityShares',
      },
      {
        id: 'id5',
        label: 'Land Or Building',
        value: 'LandOrBuilding',
      },
      {
        id: 'id6',
        label: 'Other Assets',
        value: 'OtherAssets',
      },
    ],
    onChange: () => {},
    placeholder: 'Equity Mutual Funds',
  },
  {
    id: 'HoldingPeriod',
    label: 'Holding Period',
    value: 'StLessThan1Year',
    showLabel: true,
    optionsArray: [],
    onChange: () => {},
    placeholder: 'Short Term: Less than 1 Year',
  },
];

export const holdingPeriodMapping: Record<
  string,
  { id: string; label: string; value: string }[]
> = {
  EquityMutualFunds: [
    {
      id: 'MutualSt',
      label: 'Short Term: Less than 1 Year',
      value: 'StLessThan1Year',
    },
    {
      id: 'MutualLt',
      label: 'Long Term: More than or equal to 1 year',
      value: 'LtMoreThanOrEqualTo1Year',
    },
  ],
  ListedEquityShares: [
    {
      id: 'ListedSt',
      label: 'Short Term: Less than 1 Year',
      value: 'StLessThan1Year',
    },
    {
      id: 'ListedLt',
      label: 'Long Term: More than or equal to 1 year',
      value: 'LtMoreThanOrEqualTo1Year',
    },
  ],
  NonEquityOrDebtMutualFunds: [
    {
      id: 'DebtSt',
      label: 'Short Term: Less than 3 Year',
      value: 'StLessThan3Years',
    },
    {
      id: 'DebtLt',
      label: 'Long Term: More than or equal to 3 year',
      value: 'LtMoreThanOrEqualTo3Years',
    },
  ],
  OtherAssets: [
    {
      id: 'OtherSt',
      label: 'Short Term: Less than 3 Year',
      value: 'StLessThan3Years',
    },
    {
      id: 'OtherLt',
      label: 'Long Term: More than or equal to 3 year',
      value: 'LtMoreThanOrEqualTo3Years',
    },
  ],
  UnlistedEquityShares: [
    {
      id: 'UnlistedSt',
      label: 'Short Term: Less than 2 Year',
      value: 'StLessThan2Years',
    },
    {
      id: 'UnlistedLt',
      label: 'Long Term: More than or equal to 2 year',
      value: 'LtMoreThanOrEqualTo2Years',
    },
  ],
  LandOrBuilding: [
    {
      id: 'LandSt',
      label: 'Short Term: Less than 2 Year',
      value: 'StLessThan2Years',
    },
    {
      id: 'LandLt',
      label: 'Long Term: More than or equal to 2 year',
      value: 'LtMoreThanOrEqualTo2Years',
    },
  ],
};

export const AtcBusinessProfits = [
  {
    id: 'Type',
    label: 'Category of Income',
    value: 'PresumptiveBusiness',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label:
          'Presumptive Business Income u/s 44AD (max profit limit Rs. 16,00,000)',
        value: 'PresumptiveBusiness',
      },
      {
        id: 'id2',
        label:
          'Presumptive Professional Income u/s 44ADA (max profit limit Rs. 25,00,000)',
        value: 'PresumptiveProfession',
      },
      {
        id: 'id3',
        label: 'Any Other Business Income',
        value: 'Regular',
      },
    ],
    onChange: () => {},
    placeholder:
      'Presumptive Business Income u/s 44AD (max profit limit Rs. 16,00,000)',
  },
  {
    id: 'Amount',
    label: 'Amount',
    showLabel: true,
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Please enter the profit amount',
    },
  },
];
export const AtcLeftDeductionDetails = [
  {
    label: 'Basic deductions - 80C',
    showLabel: true,
    id: 'Section80C',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount invested/paid in tax saving instruments such as PPF, ELSS mutual funds, LIC premium, etc. (max: 1.5L)',
    },
  },
  {
    label: 'Medical insurance - 80D',
    showLabel: true,
    id: 'Section80D',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Medical premium & preventive health checkup fees paid for self & family including parents',
    },
  },
  {
    label: 'Interest on educational loan - 80E',
    showLabel: true,
    id: 'Section80E',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of interest paid on loan taken for higher education',
    },
  },
  {
    label: 'Deductions other than above',
    showLabel: true,
    id: 'OtherDeductions',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Please enter the sum of deductions other than those mentioned above like 80CCC, 80CCD(2), 80DD, 80DDB, 80U, etc.',
    },
  },
];
export const AtcRightDeductionDetails = [
  {
    label: 'Interest from deposits - 80TTA',
    showLabel: true,
    id: 'Section80TTA',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of interest income on deposits in savings account (includes fixed/recurring deposit interest in case of senior citizen)',
    },
  },
  {
    label: 'Donations to charity - 80G',
    showLabel: true,
    id: 'Section80G',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount paid as donation to charitable insitutions or certain recognized funds',
    },
  },
  {
    label: 'NPS Contribution - 80CCD1(B)',
    showLabel: true,
    id: 'Section80CCD1B',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of contribution made to National Pension Scheme',
    },
  },
];
export const AtcTaxesPaidData = [
  {
    label: 'Tax deducted during the FY',
    showLabel: true,
    id: 'TdsAndTcs',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    info: {
      enabled: true,
      text: 'Enter the Total Tax deducted during the FY as appearing in your Form 26AS',
    },
  },
];
export const AtcAdvanceTaxPaid = [
  {
    id: 'Date',
    label: 'Date of Payment',
    onDateChangeFn: () => {},
    onBlurFn: () => {},
    value: '',
    showLabel: true,
    type: 'date',
    placeholder: 'Value',
    formData: {},
  },
  {
    label: 'Amount',
    showLabel: true,
    id: 'Amount',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Advance tax paid until now for current FY',
    },
  },
];
export const AdvanceTaxData: tabsData = {
  tabStyles: {
    activeStyle:
      'px-6 py-2 sm:p-[10px] sm:text-s-14 cursor-pointer font-medium border-b-md border-blue-350 text-blue-350 whitespace-nowrap',
    inActiveStyle:
      'px-6 py-2 sm:p-[10px] sm:text-s-14 cursor-pointer  font-medium text-blue-200 text-[#9092a3] whitespace-nowrap',
    isButton: true,
  },
  tabs: [
    { index: 0, label: 'Basic details', component: AtcBasicDetails },
    { index: 1, label: 'Income details', component: AtcIncomeDetails },
    { index: 2, label: 'Deduction', component: AtcDeductions },
    { index: 3, label: 'Taxes Paid', component: AtcTaxPaid },
  ],
};

export const AtctaxRegimeTab: AtctabsData = {
  tabStyles: {
    activeStyle:
      'px-4 py-2 sm:p-0 sm:pb-2.5 md:p-0 md:pb-2 sm:text-s-14 sm:font-medium md:text-s-12 flex items-center gap-2 cursor-pointer font-medium border-b-md border-blue-350 text-font-500 font-medium',
    inActiveStyle:
      'px-4 py-2 sm:p-0 sm:pb-2.5 md:p-0 md:pb-2 sm:text-s-14 sm:font-medium md:text-s-12 flex items-center gap-2 cursor-pointer font-medium text-font-200 border-b-md border-b-white ',
    isButton: false,
  },
  tabs: [
    { index: 0, label: 'Old regime', component: AtcGraphCalculation },
    { index: 1, label: 'New regime', component: AtcGraphCalculation },
  ],
};

export const SumaryRows = [
  { label: 'Percentage To Be Deposited', key: 'percentageToBeDeposited' },
  { label: 'Advance Tax To Be Deposited', key: 'taxToBeDeposited' },
  { label: 'Advance Tax Paid', key: 'taxPaid' },
  { label: 'Advance Tax Due For Quarter', key: 'taxDueForQuarter' },
];
